<template lang="html">
  <div class="fsd-job-template__basic">
    <div v-for="(card, idx) in htmlCards" :key="idx" class="card">
      <!-- eslint-disable vue/no-v-html -->
      <div class="fsd-job-template__basic-content" v-html="card.html" />
    </div>

    <div v-if="hasMinimalContactInfo" class="card">
      <div class="fsd-job-template__basic-content">
        <h2>
          {{ contactPersonHeadline }}
        </h2>
        <div>{{ contactPerson }}</div>
        <div v-if="department" class="fsd-job-template__basic-content--detail">
          {{ department }}
        </div>
        <div v-if="contactPersonPhone">
          {{ contactPersonPhone }}
        </div>
        <div v-if="contactPersonEmail">
          <a :href="`mailto:${contactPersonEmail}`">{{ contactPersonEmail }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash-es/get'

const HTML_FIELDS = [
  'companyDescription',
  'responsibilities',
  'qualifications',
  'jobBenefits',
  'specialCommitments'
]

export default {
  props: {
    job: { type: Object, required: true }
  },
  data: () => {
    return {}
  },
  computed: {
    htmlCards() {
      return HTML_FIELDS.reduce((cards, field) => {
        if (this.job && this.job.data && this.job.data[field]) {
          cards.push({ html: this.job.data[field] })
        }
        return cards
      }, [])
    },
    contactPerson() {
      const person = _get(this.job, 'data.contactPerson')
      const salutation = _get(this.job, 'data.contactPersonSalutation')

      return salutation && person ? `${salutation} ${person}` : person
    },
    contactPersonHeadline() {
      return (
        _get(this.job, 'data.contactPersonHeadline') ||
        this.$options.filters.t('client.job_card.contact.headline')
      )
    },
    contactPersonPhone() {
      return _get(this.job, 'data.contactPersonPhone')
    },
    contactPersonEmail() {
      return _get(this.job, 'data.applyEmail')
    },
    department() {
      return _get(this.job, 'data.department')
    },
    hasMinimalContactInfo() {
      return !!(
        this.job &&
        this.contactPerson &&
        (this.contactPersonPhone || this.contactPersonEmail)
      )
    }
  },
  methods: {}
}
</script>
